<form [formGroup]="contactForm" (ngSubmit)="onSubmit(contactForm)" style="color:#495057!important ">
  <div class="row gx-3">
    <div class="form-group col-md-6">
      <label for="name" class="form-label form-label-required">
        {{ 'contacts-form.contactNameLabel' | translate }}
      </label>

      <input
        class="form-control"
        id="name"
        formControlName="name"
        name="name"
        type="text"
        [class.invalid-field]="contactForm.get('name').dirty && contactForm.get('name').invalid"
        [placeholder]="'contacts-form.contactNamePlaceHolder' | translate"
      />
    </div>

    <div class="form-group col-md-6">
      <label for="lastName" class="form-label">
        {{ 'contacts-form.contactLastNameLabel' | translate }}
      </label>

      <input
        class="form-control"
        id="lastName"
        formControlName="lastName"
        name="lastName"
        type="text"
        [class.invalid-field]="contactForm.get('lastName').dirty && contactForm.get('lastName').invalid"
        [placeholder]="'contacts-form.contactLastNamePlaceHolder' | translate" 
      />
    </div>
  </div>

  <div class="row gx-3">
    <div class="form-group col-md-6">
      <label for="phoneNumber" class="form-label">
        {{ 'contacts-form.phoneNumberLabel' | translate }}
      </label>

      <ngx-intl-tel-input
        [preferredCountries]="preferredCountries"
        [enableAutoCountrySelect]="true"
        [searchCountryFlag]="true"
        [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
        [selectFirstCountry]="false" 
        [selectedCountryISO]="CountryISO.UnitedStates"
        [maxLength]="15" 
        [phoneValidation]="true" 
        [separateDialCode]="true"
        name="phoneNumber"
        formControlName="phoneNumber">
      </ngx-intl-tel-input>

      <div *ngIf="(contactForm.get('phoneNumber').dirty && contactForm.controls['phoneNumber'].invalid) || (contactForm.get('phoneNumber').value!=null && contactForm.errors?.invalidPhoneAndEmail) " class="lbl-phone-invalid">
        {{ 'contacts-form.invalidPhoneNumberWarn' | translate }}
      </div>
    </div>

    <div class="form-group col-md-6">
      <label for="email" class="form-label">
        {{ 'contacts-form.emailLabel' | translate }}
      </label>

      <input formControlName="email" name="email" id="email" placeholder="john@mail.com" type="email" class="form-control"
      [ngClass]="(contactForm.get('email').dirty && contactForm.errors?.invalidPhoneAndEmail) || contactForm.get('email').invalid ? 'invalid-field' : ''">
    </div>

    <div class="position-relative form-group" *ngIf="(campaigns$ | async).length > 1">
      <label for="campaign" class="form-label">
        Campaign
        <icon-info class="ms-1" ngbTooltip="Choose the campaign you'd like this contact to receive" />
      </label>


      <app-campaign-dropdown
        [campaignsBasicInfo]="campaigns$ | async"
        [multiSelect]="false"
        [selectedCampaigns]="selectedCampaign"
        (onSelect)="changeContactCampaign($event)"
      />
    </div>
  </div>

  <ng-container *ngIf="false">
    <div style="font-size: 12px">
      * Required fields
    </div>

    <div style="font-size: 12px">
      * Either phone number or email must be filled
    </div>
  </ng-container>

  <div class="d-flex w-100 justify-content-between align-items-center">
    <div *ngIf="!create" class="text-danger mt-2 me-2">
      If this contact is in an active campaign, it will be re-sent to contact once edited
    </div>

    <button
      class="mt-2 btn btn-primary"
      type="submit"
      [class.btn-outline-secondary]="!contactForm.valid"
      [disabled]="!contactForm.valid"
    >
      {{create ? 'Send' : 'Save'}}
    </button>
  </div>
</form>
